const selectors = {
  returnForm: 'return-form',
  emailInput: 'email-input',
  orderNumberInput: 'order-number-input',
  firstNameInput: 'first-name-input',
  lastNameInput: 'last-name-input',
  phoneNumberInput: 'phone-number-input',
  stateInput: 'state-input',
  countryInput: 'country-input',
  cityInput: 'city-input',
  addressInput: 'address-input',
  zipCodeInput: 'zip-code-input',
  additionalAddressInfoInput: 'additional-address-info-input',
  detailedReturnReasonInput: 'detailed-return-reason-input',
  submitFormButton: 'submit-form-button',
  cancelFormButton: 'cancel-form-button',
  submitText: 'submit-text',
  returnFormError: 'return-form-error',
  returnFormSuccess: 'return-form-success',
  returnFormItems: 'return-form-items',
  itemAccordionTemplate: 'item-accordion-template',
  itemSummaryTextTemplate: 'item-summary-text-template',
  itemReasonSelectLabelTemplate: 'item-reason-select-label-template',
  itemReasonSelectTemplate: 'item-reason-select-template',
  itemQuantityLabelTemplate: 'item-quantity-label-template',
  itemQuantityTemplate: 'item-quantity-template',
  itemCheckboxTemplate: 'item-checkbox-template',
  itemAccordionSummaryTemplate: 'item-accordion-summary-template',
}

const returnFormStrings = window.returnFormStrings || {}
const returnFormFederationURL = window.returnFormFederationURL || 'https://public-federation.dev.soundboks.com'

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
}

// Taken from https://github.com/SOUNDBOKS/sb-error-codes/blob/main/src/index.ts
const ErrorCode = {
  NO_ORDER_FOUND: 'NO_ORDER_FOUND',
  WRONG_ORDER_EMAIL: 'WRONG_ORDER_EMAIL',
  RETURN_ORDER_PERIOD_EXPIRED: 'RETURN_ORDER_PERIOD_EXPIRED',
  RETURN_ORDER_WRONG_STATUS: 'RETURN_ORDER_WRONG_STATUS',
}

class ReturnForm {
  accordions = []
  fetchedOrder

  constructor() {
    this.elements = this._getElements()
    if (Object.keys(this.elements).length === 0) return

    this._setupEventListeners()
    this.elements.submitText.innerText = returnFormStrings.fetchOrderSubmit
    this._setFormValidity()
    this.elements.returnFormError.classList.add('hidden')
    this.elements.returnFormSuccess.classList.add('hidden')
  }

  _getElements() {
    return {
      returnForm: document.getElementById(selectors.returnForm),
      submitFormButton: document.getElementById(selectors.submitFormButton),
      cancelFormButton: document.getElementById(selectors.cancelFormButton),
      submitText: document.getElementById(selectors.submitText),
      orderNumberInput: document.getElementById(selectors.orderNumberInput),
      emailInput: document.getElementById(selectors.emailInput),
      firstNameInput: document.getElementById(selectors.firstNameInput),
      lastNameInput: document.getElementById(selectors.lastNameInput),
      phoneNumberInput: document.getElementById(selectors.phoneNumberInput),
      stateInput: document.getElementById(selectors.stateInput),
      countryInput: document.getElementById(selectors.countryInput),
      cityInput: document.getElementById(selectors.cityInput),
      addressInput: document.getElementById(selectors.addressInput),
      zipCodeInput: document.getElementById(selectors.zipCodeInput),
      additionalAddressInfoInput: document.getElementById(selectors.additionalAddressInfoInput),
      detailedReturnReasonInput: document.getElementById(selectors.detailedReturnReasonInput),
      returnFormItems: document.getElementById(selectors.returnFormItems),
      itemAccordionTemplate: document.getElementById(selectors.itemAccordionTemplate),
      returnFormError: document.getElementById(selectors.returnFormError),
      returnFormSuccess: document.getElementById(selectors.returnFormSuccess),
    }
  }

  _setupEventListeners() {
    // this.elements.emailInput.addEventListener('blur', this._handleValidation(this._validateEmail));
    this.elements.emailInput.addEventListener('input', this._handleValidation(this._validateEmail))
    this.elements.orderNumberInput.addEventListener('blur', this._handleValidation(this._validateOrderNumber))
    this.elements.orderNumberInput.addEventListener('input', this._handleValidation(this._validateOrderNumber))
    this.elements.firstNameInput.addEventListener('blur', this._handleValidation(this._validateFirstName))
    this.elements.firstNameInput.addEventListener('input', this._handleValidation(this._validateFirstName))
    this.elements.lastNameInput.addEventListener('blur', this._handleValidation(this._validateLastName))
    this.elements.lastNameInput.addEventListener('input', this._handleValidation(this._validateLastName))
    this.elements.phoneNumberInput.addEventListener('blur', this._handleValidation(this._validatePhoneNumber))
    this.elements.phoneNumberInput.addEventListener('input', this._handleValidation(this._validatePhoneNumber))
    this.elements.countryInput.addEventListener('blur', this._handleValidation(this._validateCountry))
    this.elements.countryInput.addEventListener('input', this._handleValidation(this._validateCountry))
    this.elements.stateInput.addEventListener('blur', this._handleValidation(this._validateState))
    this.elements.stateInput.addEventListener('input', this._handleValidation(this._validateState))
    this.elements.cityInput.addEventListener('blur', this._handleValidation(this._validateCity))
    this.elements.cityInput.addEventListener('input', this._handleValidation(this._validateCity))
    this.elements.zipCodeInput.addEventListener('blur', this._handleValidation(this._validateZipCode))
    this.elements.zipCodeInput.addEventListener('input', this._handleValidation(this._validateZipCode))
    this.elements.addressInput.addEventListener('blur', this._handleValidation(this._validateAddress))
    this.elements.addressInput.addEventListener('input', this._handleValidation(this._validateAddress))
    this.elements.additionalAddressInfoInput.addEventListener(
      'blur',
      this._handleValidation(this._validateAdditionalAddress)
    )
    this.elements.additionalAddressInfoInput.addEventListener(
      'input',
      this._handleValidation(this._validateAdditionalAddress)
    )
    this.elements.detailedReturnReasonInput.addEventListener(
      'blur',
      this._handleValidation(this._validateDetailedReturnReason)
    )
    this.elements.detailedReturnReasonInput.addEventListener(
      'input',
      this._handleValidation(this._validateDetailedReturnReason)
    )
    this.elements.submitFormButton.addEventListener('click', this._handleFetchOrderButtonClick)
    this.elements.cancelFormButton.addEventListener('click', this._handleCancelButtonClick)
  }

  _handleFetchOrderButtonClick = async ({ currentTarget }) => {
    this._lockFetchOrderForm()
    this.elements.submitFormButton.disabled = true
    this.elements.submitFormButton.ariaBusy = true
    this.elements.returnFormError.classList.add('hidden')
    this.elements.returnFormSuccess.classList.add('hidden')

    const [resOrder, resReasons] = await Promise.all([
      this._fetchOrder(this.elements.emailInput.value, this.elements.orderNumberInput.value),
      this._fetchReturnReasons(),
    ])

    this.elements.submitFormButton.ariaBusy = false

    if (resOrder?.errors || resReasons?.errors) {
      this.elements.submitFormButton.disabled = false
      this._unlockFetchOrderForm()
      this._handleFetchErrors(resOrder?.errors || resReasons?.errors)
      return
    }

    if (resOrder?.data?.orderSoundboksReturn && resReasons?.data?.returnReasons) {
      this._prefillHiddenFields(
        resOrder.data.orderSoundboksReturn,
        resReasons.data.returnReasons.filter((reason) => reason.type === 'Return')
      )
      this.elements.submitFormButton.removeEventListener('click', this._handleFetchOrderButtonClick)
      this.elements.submitFormButton.addEventListener('click', this._handleCreateReturnButtonClick)
      this.fetchedOrder = resOrder.data.orderSoundboksReturn
      this.elements.submitText.innerText = returnFormStrings.createReturnSubmit
    }
  }

  _prefillHiddenFields(order, returnReasons) {
    const [firstName, lastName] = order.shippingAddressAddressee.split(' ')

    if (firstName) this.elements.firstNameInput.value = firstName
    if (lastName) this.elements.lastNameInput.value = lastName
    if (order.shippingPhone) this.elements.phoneNumberInput.value = order.shippingPhone
    if (order.shippingAddressState) this.elements.stateInput.value = order.shippingAddressState
    if (order.shippingAddressCountryName) this.elements.countryInput.value = order.shippingAddressCountryName
    if (order.shippingAddressCity) this.elements.cityInput.value = order.shippingAddressCity
    if (order.shippingAddress1) this.elements.addressInput.value = order.shippingAddress1
    if (order.shippingAddressZip) this.elements.zipCodeInput.value = order.shippingAddressZip

    this.elements.firstNameInput.parentElement.classList.remove('hidden')
    this.elements.lastNameInput.parentElement.classList.remove('hidden')
    this.elements.phoneNumberInput.parentElement.classList.remove('hidden')
    this.elements.stateInput.parentElement.classList.remove('hidden')
    this.elements.countryInput.parentElement.classList.remove('hidden')
    this.elements.cityInput.parentElement.classList.remove('hidden')
    this.elements.addressInput.parentElement.classList.remove('hidden')
    this.elements.zipCodeInput.parentElement.classList.remove('hidden')
    this.elements.additionalAddressInfoInput.parentElement.classList.remove('hidden')
    this.elements.itemAccordionTemplate.parentElement.classList.remove('hidden')
    this.elements.detailedReturnReasonInput.parentElement.classList.remove('hidden')

    this.elements.firstNameInput.required = true
    this.elements.lastNameInput.required = true
    this.elements.phoneNumberInput.required = true
    this.elements.countryInput.required = true
    this.elements.cityInput.required = true
    this.elements.addressInput.required = true
    this.elements.zipCodeInput.required = true

    this._clearItemAccordions()
    this.accordions = order.items.map((item, index) => {
      const itemAccordionData = this._createItemAccordion(item, index, returnReasons)
      this.elements.returnFormItems.appendChild(itemAccordionData.element)
      itemAccordionData.element.classList.remove('hidden')
      return itemAccordionData
    })
  }

  _handleCreateReturnButtonClick = async ({ currentTarget }) => {
    this._lockCreateReturnForm()
    this.elements.submitFormButton.disabled = true
    this.elements.submitFormButton.ariaBusy = true
    this.elements.returnFormError.classList.add('hidden')
    this.elements.returnFormSuccess.classList.add('hidden')

    const data = {
      email: this.elements.emailInput.value,
      poNumber: this.elements.orderNumberInput.value,
      salesOrderInternalId: this.fetchedOrder.salesOrderInternalId,
      firstName: this.elements.firstNameInput.value,
      lastName: this.elements.lastNameInput.value,
      phoneNumber: this.elements.phoneNumberInput.value,
      city: this.elements.cityInput.value,
      address: this.elements.addressInput.value,
      zipCode: this.elements.zipCodeInput.value,
      additionalAddress: this.elements.additionalAddressInfoInput.value,
      detailedReturnReason: this.elements.detailedReturnReasonInput.value,
      customerId: this.fetchedOrder.customerId,
      returnReason: 'Return',
      items: this.accordions
        .filter(({ itemCheckbox }) => itemCheckbox.checked)
        .map(({ item, itemQuantity, itemReasonSelect }) => ({
          itemInternalId: item.itemInternalId,
          quantity: Number(itemQuantity.value),
          returnReason: itemReasonSelect.value,
          rate: item.rate,
        })),
    }

    const res = await this._createReturnRA(data)

    this.elements.submitFormButton.ariaBusy = false
    this.elements.submitFormButton.disabled = false

    if (res?.errors) {
      this._unlockCreateReturnForm()
      this._handleFetchErrors(res.errors)
      return
    }

    this._handleCancelButtonClick()

    if (res.data.createReturnRA) {
      this.elements.returnFormSuccess.childNodes[2].nodeValue = returnFormStrings.returnFormSuccess
    } else {
      this.elements.returnFormSuccess.childNodes[2].nodeValue = returnFormStrings.returnFormPartlySuccess
    }

    this.elements.returnFormSuccess.classList.remove('hidden')
  }

  _handleCancelButtonClick = () => {
    this.elements.returnForm.reset()
    this.elements.firstNameInput.parentElement.classList.add('hidden')
    this.elements.lastNameInput.parentElement.classList.add('hidden')
    this.elements.phoneNumberInput.parentElement.classList.add('hidden')
    this.elements.stateInput.parentElement.classList.add('hidden')
    this.elements.countryInput.parentElement.classList.add('hidden')
    this.elements.cityInput.parentElement.classList.add('hidden')
    this.elements.addressInput.parentElement.classList.add('hidden')
    this.elements.zipCodeInput.parentElement.classList.add('hidden')
    this.elements.additionalAddressInfoInput.parentElement.classList.add('hidden')
    this.elements.detailedReturnReasonInput.parentElement.classList.add('hidden')
    this.elements.itemAccordionTemplate.parentElement.classList.add('hidden')
    this.elements.returnFormError.classList.add('hidden')
    this.elements.returnFormSuccess.classList.add('hidden')
    this.elements.submitFormButton.removeEventListener('click', this._handleCreateReturnButtonClick)
    this.elements.submitFormButton.addEventListener('click', this._handleFetchOrderButtonClick)
    this.elements.submitText.innerText = returnFormStrings.fetchOrderSubmit
    this.elements.returnFormError.childNodes[2].nodeValue = ''
    this.elements.returnFormSuccess.childNodes[2].nodeValue = ''

    this._unlockFetchOrderForm()
    this._unlockCreateReturnForm()

    this._clearItemAccordions()
    this._fetchedOrder = null
    this._setFormValidity()

    this.elements.emailInput.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
  }

  _handleValidation = (validateFunc) => (event) => {
    this.elements.returnFormError.classList.add('hidden')
    this.elements.returnFormSuccess.classList.add('hidden')

    if (!event.target.required || validateFunc(event.target.value)) {
      this._setValid(event.target)
    } else {
      this._setInvalid(event.target)
    }

    this._setFormValidity()
  }

  _validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  _validateOrderNumber(orderNumber) {
    return /#?\d+-\d+/g.test(orderNumber)
  }

  _validateFirstName(firstName) {
    return firstName && firstName.length >= 2 && firstName.length < 190
  }

  _validateLastName(lastName) {
    return lastName && lastName.length >= 2 && lastName.length < 190
  }

  _validatePhoneNumber(phoneNumber) {
    return /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/.test(phoneNumber)
  }

  _validateCountry(country) {
    return country && country.length > 3 && country.length < 190
  }

  _validateState(state) {
    return !state || state.length < 190
  }

  _validateCity(city) {
    return city && city.length < 190
  }

  _validateZipCode(zipCode) {
    return zipCode && zipCode.length < 190
  }

  _validateAddress(address) {
    // the restriction comes from Webshipper when  creating a label
    return address && address.length < 40
  }

  _validateAdditionalAddress(additionalAddress) {
    // the restriction comes from Webshipper when  creating a label
    return !additionalAddress || additionalAddressaddress.length < 40
  }

  _validateDetailedReturnReason() {
    return true
  }

  _validateItem = (data) => () => {
    return data.itemCheckbox.checked && data.itemQuantity.value > 0 && data.itemReasonSelect.value !== '-'
  }

  _setInvalid(element) {
    element.classList.add('invalid')
  }

  _setValid(element) {
    element.classList.remove('invalid')
  }

  _isHidden(element) {
    return window.getComputedStyle(element).display === 'none'
  }

  _lockCreateReturnForm() {
    //Note: country and state should always remain disabled
    this.elements.firstNameInput.disabled = true
    this.elements.lastNameInput.disabled = true
    this.elements.phoneNumberInput.disabled = true
    this.elements.cityInput.disabled = true
    this.elements.zipCodeInput.disabled = true
    this.elements.addressInput.disabled = true
    this.elements.additionalAddressInfoInput.disabled = true
    this.elements.detailedReturnReasonInput.disabled = true

    this.accordions.forEach((data) => {
      data.itemCheckbox.disabled = true
      data.itemReasonSelect.disabled = true
      data.itemQuantity.disabled = true
    })
  }

  _lockFetchOrderForm() {
    this.elements.emailInput.disabled = true
    this.elements.orderNumberInput.disabled = true
  }

  _unlockCreateReturnForm() {
    //Note: country and state should always remain disabled
    this.elements.firstNameInput.disabled = false
    this.elements.lastNameInput.disabled = false
    this.elements.phoneNumberInput.disabled = false
    this.elements.cityInput.disabled = false
    this.elements.zipCodeInput.disabled = false
    this.elements.addressInput.disabled = false
    this.elements.additionalAddressInfoInput.disabled = false
    this.elements.detailedReturnReasonInput.disabled = false

    this.accordions.forEach((data) => {
      data.itemCheckbox.disabled = false
      data.itemReasonSelect.disabled = false
      data.itemQuantity.disabled = false
    })
  }

  _unlockFetchOrderForm() {
    this.elements.emailInput.disabled = false
    this.elements.orderNumberInput.disabled = false
  }

  _setFormValidity() {
    if (
      (this._isHidden(this.elements.emailInput.parentElement) || this._validateEmail(this.elements.emailInput.value)) &&
      (this._isHidden(this.elements.orderNumberInput.parentElement) ||
        this._validateOrderNumber(this.elements.orderNumberInput.value)) &&
      (this._isHidden(this.elements.firstNameInput.parentElement) ||
        this._validateFirstName(this.elements.firstNameInput.value)) &&
      (this._isHidden(this.elements.lastNameInput.parentElement) ||
        this._validateLastName(this.elements.lastNameInput.value)) &&
      (this._isHidden(this.elements.phoneNumberInput.parentElement) ||
        this._validatePhoneNumber(this.elements.phoneNumberInput.value)) &&
      (this._isHidden(this.elements.countryInput.parentElement) ||
        this._validateCountry(this.elements.countryInput.value)) &&
      (this._isHidden(this.elements.stateInput.parentElement) || this._validateState(this.elements.stateInput.value)) &&
      (this._isHidden(this.elements.cityInput.parentElement) || this._validateCity(this.elements.cityInput.value)) &&
      (this._isHidden(this.elements.zipCodeInput.parentElement) ||
        this._validateZipCode(this.elements.zipCodeInput.value)) &&
      (this._isHidden(this.elements.addressInput.parentElement) ||
        this._validateAddress(this.elements.addressInput.value)) &&
      (this._isHidden(this.elements.additionalAddressInfoInput.parentElement) ||
        this._validateAdditionalAddress(this.elements.additionalAddressInfoInput.value)) &&
      (!this.accordions.length || (this._isAnyItemSelected() && !this._isAnySelectedItemInvalid()))
    ) {
      this.elements.submitFormButton.disabled = false
    } else {
      this.elements.submitFormButton.disabled = true
    }
  }

  async _fetchOrder(email, orderNumber) {
    try {
      const response = await fetch(returnFormFederationURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify({
          query: `
            query OrderSoundboks($orderId: String!, $email: String!, $orderType: String!) {
              orderSoundboksReturn(orderId: $orderId, email: $email, orderType: $orderType) {
                items {
                  itemInternalId
                  quantity
                  amount
                  rate
                  description
                  quantity
                  salesOrderInternalId
                  type
                }
                salesOrderId
                otherRefNum
                email
                customerId
                createdDate
                retailOrderId
                salesOrderInternalId
                orderStatus
                shippingAddress1
                shippingAddressAddressee
                shippingAddressAttention
                shippingAddressCity
                shippingAddressCountryName
                shippingAddressCountryCode
                shippingAddressState
                shippingAddressZip
                shippingPhone
              }
            }
        `,
          variables: {
            orderId: orderNumber,
            email,
            orderType: 'soundboks',
          },
        }),
      })

      const res = await response.json()

      return res
    } catch (e) {
      return { errors: [e] }
    }
  }

  async _createReturnRA(data) {
    try {
      const response = await fetch(returnFormFederationURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify({
          query: `
            mutation CreateReturnRA($returnOrder: ReturnOrderInput!) {
              createReturnRA(returnOrder: $returnOrder)
            }
        `,
          variables: {
            returnOrder: data,
          },
        }),
      })

      const res = await response.json()

      return res
    } catch (e) {
      return { errors: [e] }
    }
  }

  async _fetchReturnReasons() {
    try {
      const response = await fetch(returnFormFederationURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify({
          query: `
            query ReturnReasons {
              returnReasons {
                name
                type
                internalId
              }
            }
        `,
        }),
      })

      const res = await response.json()

      return res
    } catch (e) {
      return { errors: [e] }
    }
  }

  _handleFetchErrors(errors) {
    const [error] = errors || []
    if (!error) return

    const message = this._getErrorMessage(error.extensions?.code)
    this.elements.returnFormError.childNodes[2].nodeValue = message
    this.elements.returnFormError.classList.remove('hidden')
    this.elements.returnFormSuccess.classList.add('hidden')
  }

  _getErrorMessage(errorCode) {
    switch (errorCode) {
      case ErrorCode.NO_ORDER_FOUND:
        return returnFormStrings.errorFetchOrderNotFound
      case ErrorCode.WRONG_ORDER_EMAIL:
        return returnFormStrings.errorFetchOrderEmailAddressNotMatching
      case ErrorCode.RETURN_ORDER_PERIOD_EXPIRED:
        return returnFormStrings.errorFetchOrderReturnExpired
      case ErrorCode.RETURN_ORDER_WRONG_STATUS:
        return returnFormStrings.errorFetchOrderWrongStatus
      default:
        return returnFormStrings.errorFetchOrderCouldNotFetch
    }
  }

  _createItemAccordion(item, index, reasons) {
    const itemAccordion = this.elements.itemAccordionTemplate.cloneNode(true)
    const itemSummaryText = itemAccordion.querySelector(`#${selectors.itemSummaryTextTemplate}`)
    const itemReasonSelectLabel = itemAccordion.querySelector(`#${selectors.itemReasonSelectLabelTemplate}`)
    const itemReasonSelect = itemAccordion.querySelector(`#${selectors.itemReasonSelectTemplate}`)
    const itemQuantityLabel = itemAccordion.querySelector(`#${selectors.itemQuantityLabelTemplate}`)
    const itemQuantity = itemAccordion.querySelector(`#${selectors.itemQuantityTemplate}`)
    const itemCheckbox = itemAccordion.querySelector(`#${selectors.itemCheckboxTemplate}`)
    const itemAccordionSummary = itemAccordion.querySelector(`#${selectors.itemAccordionSummaryTemplate}`)

    itemSummaryText.id = `item-summary-text-${index}`
    itemSummaryText.innerText = item.description

    itemReasonSelect.id = `item-reason-select-${index}`
    itemReasonSelect.required = true
    itemReasonSelectLabel.id = `item-reason-select-label-${index}`
    itemReasonSelectLabel.for = itemReasonSelect.id

    itemQuantity.id = `item-quantity-${index}`
    itemQuantity.max = item.quantity
    itemQuantity.required = true
    itemQuantityLabel.id = `item-quantity-label-${index}`
    itemQuantityLabel.for = itemQuantity.id

    itemCheckbox.id = `item-checkbox-${index}`
    itemCheckbox.name = `return_form[item_checkbox_${index}]`
    itemAccordionSummary.id = `item-accordion-summary-${index}`
    const itemAccordionDetails = itemAccordionSummary.parentElement

    const toggleObserver = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === attributes.expanded) {
          // The accordion is implemented to prevent the default event when clicking the checkbox
          // Timeout pushes the execution untill the checkbox has been reset due to prevent default
          setTimeout(() => {
            itemCheckbox.checked = mutation.target.getAttribute(attributes.expanded) === 'true'
            this._setFormValidity()
          })
        }
      }
    })

    toggleObserver.observe(itemAccordionDetails, { attributes: true })

    // Use summary as the single source of truth for toggling:
    // clicking anywhere on summary toggles checkbox + accordion together.
    itemAccordionSummary.addEventListener('click', (event) => {
      if (!itemAccordionDetails) return

      event.preventDefault()

      const shouldExpand = !itemAccordionDetails.open
      itemAccordionDetails.open = shouldExpand
      // Apply checked state after click default handling so visual state
      // stays in sync even when the click originates on the checkbox itself.
      setTimeout(() => {
        itemCheckbox.checked = shouldExpand
        this._setFormValidity()
      })
    })

    reasons.forEach((reason) => {
      const option = document.createElement('option')
      option.value = reason.internalId
      option.innerText = reason.name
      itemReasonSelect.appendChild(option)
    })

    itemQuantity.addEventListener('input', () => {
      this._setFormValidity()
    })

    itemReasonSelect.addEventListener('input', () => {
      this._setFormValidity()
    })

    const data = {
      element: itemAccordion,
      item,
      itemCheckbox,
      itemReasonSelect,
      itemQuantity,
    }

    return data
  }

  _isAnyItemSelected() {
    return this.accordions.some(
      (accordion) =>
        accordion.itemCheckbox.checked && accordion.itemQuantity.value > 0 && accordion.itemReasonSelect.value !== '-'
    )
  }

  _isAnySelectedItemInvalid() {
    return this.accordions.some(
      (accordion) =>
        accordion.itemCheckbox.checked && (accordion.itemQuantity.value < 1 || accordion.itemReasonSelect.value === '-')
    )
  }

  _clearItemAccordions() {
    this.accordions.forEach((data) => data.element.remove())
    this.accordions = []
  }
}
